import * as Sentry from '@sentry/nextjs';

import { dateToYYYYMMDD } from '@datetime';
import { AvailabilityModel, GetAvailabilitiesParamsModel } from '@models';
import { APIRequestLabel } from '../consts';
import { callHttpGet, callHttpPost } from '../http';

const getAvailabilities = (get, set) => {
  return async (params: GetAvailabilitiesParamsModel): Promise<AvailabilityModel[]> => {
    let queryParams = {};
    if (params.day) {
      queryParams['day'] = dateToYYYYMMDD(params.day);
    }
    if (params.numberOfNextDays) {
      queryParams['number_of_next_days'] = params.numberOfNextDays;
    }
    if (
      params.includeDefaultAvailability !== undefined &&
      params.includeDefaultAvailability !== null
    ) {
      queryParams['include_default_availability'] = params.includeDefaultAvailability;
    }

    await callHttpGet(
      get,
      set,
      APIRequestLabel.GET_AVAILABILITIES,
      `/schedule/availabilities`,
      {},
      queryParams
    );
    let apiCallStatus = get().apiCallStatus[APIRequestLabel.GET_AVAILABILITIES];
    if (apiCallStatus.error) {
      Sentry.captureMessage(JSON.stringify(apiCallStatus.error));
      return [];
    }

    set({ availabilities: apiCallStatus.response.availabilities });
    return apiCallStatus.response.availabilities;
  };
};

const createOrUpdateAvailability = (get, set) => {
  return async (availability) => {
    await callHttpPost(
      get,
      set,
      APIRequestLabel.CREATE_OR_UPDATE_AVAILABILITY,
      `/schedule/availabilities`,
      availability
    );
    let apiCallStatus = get().apiCallStatus[APIRequestLabel.CREATE_OR_UPDATE_AVAILABILITY];
    if (apiCallStatus.error) {
      Sentry.captureMessage(JSON.stringify(apiCallStatus.error));
      return;
    }

    // update availability for that day
    let availabilities = get().availabilities;
    // find the availability for that day
    let availabilityIndex = availabilities.findIndex((a) => a.day === availability.day);
    if (availabilityIndex === -1) {
      // if not found, add it
      availabilities.push(availability);
    } else {
      // if found, update it
      availabilities[availabilityIndex] = availability;
    }

    set({ availabilities });
  };
};

export { createOrUpdateAvailability, getAvailabilities };
